import React, {useState} from "react"
import PropTypes from "prop-types"
import {Collapse, CardBody, Card, CardText} from "reactstrap"

import {createMarkup} from "../../utils/Helpers"

export const FaqComponent = ({question}) => {
  const [isCollapsed, setIsCollapsed] = useState(false)

  const toggle = () => {
    setIsCollapsed(!isCollapsed)
  }

  const NoDetailTextCard = () => {
    return (
      <>
        <Card style={{border: "none"}}>
          <CardBody className="faq-card-body">
            <CardText className="faq-card-text" dangerouslySetInnerHTML={createMarkup(question.itemText)} />
          </CardBody>
        </Card>
      </>
    )
  }

  const DetailTextCard = () => {
    return (
      <>
      <div onClick={toggle}>
        <span className="pointer" >{isCollapsed ? "- " : "+ "}</span>
        <span className="pointer">{question.itemText}</span>
      </div>
      <Collapse isOpen={isCollapsed}>
        <Card style={{border: "none"}}>
          <CardBody className="faq-card-body">
            <CardText className="faq-card-text" dangerouslySetInnerHTML={createMarkup(question.detailText)} />
          </CardBody>
        </Card>
      </Collapse>
    </>
    )
  }

  return (
    <>
      {question.detailText !== null ? <DetailTextCard /> : <NoDetailTextCard /> }
    </>
  )
}

FaqComponent.propTypes = {
  question: PropTypes.object.isRequired
}
